(function () {
  'use strict';

  /* @ngdoc object
   * @name exports.exports.list
   * @description
   *
   */
  angular
    .module('exports.exports.list', [
      'ui.router'
    ]);
}());
